import React from 'react';
import { Modal, Input, Form, Select, Icon, DatePicker, Tabs, Divider } from 'antd';
import dialog from '../../../common/utility/dialog';
import moment from "moment";
import { FORMAT_2DECIMALS, FORMAT_3DECIMALS, FORMAT_5DECIMALS, FORMAT_NUMBER_NO_ZERO, GREATER_THAN_ZERO } from "../../../common/types/regularExpresionType";
import global from '../../../common/utility/global';

import CierreSoles from './CierreSoles';
import CierreDolares from './CierreDolares';

const { Option } = Select;
const InputGroup = Input.Group;
const { Search } = Input;
const { TabPane } = Tabs;

class FormModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }

    handleCompleteDecimals = (property, value) => {
        if (value === "" || isNaN(parseFloat(value).toFixed(3)))
            this.props.form.setFieldsValue({ [property]: "0.000" });
        else
            this.props.form.setFieldsValue({
                [property]: parseFloat(value).toFixed(3),
            });
    };

    handleCancel = () => {
        this.props.onClose();
        this.props.form.resetFields();
    }

    handleOk = (e) => {
        e.preventDefault();
        this.props.form.validateFieldsAndScroll((err, values) => {

            if (!err) {

                var detalleSoles = this.props.form.getFieldValue("detalleSoles");
                var detalleDolares = this.props.form.getFieldValue("detalleDolares");

                const form = {
                    id: values.id,
                    fechaCierre: values.fechaCierre.format("DD/MM/YYYY"),
                    montoApertura: parseFloat(values.montoApertura),
                    montoFinal: parseFloat(values.montoSaldo),
                    idEmpleadoArqueo: values.idEmpleadoArqueo.key,
                    listaEfectivo: values.idMoneda.key == 1 ? detalleSoles.filter(value => value.cantidad > 0) : detalleDolares.filter(value => value.cantidad > 0)
                }

                const validFormLogic = this.validateFormLogic(form, values);
                if (!validFormLogic) {
                    return;
                }
                this.props.onSave(form, this.props.form);
            }
        });
    }

    validateFormLogic = (data, values) => {

        if (data.idEmpleadoArqueo === 0) {
            dialog.warning("Responsable ingresado es invalido.");
            return false;
        }
        if (data.montoFinal > this.props.formValues.montoApertura) {
            dialog.warning("El monto a final tiene que ser menor o igual al monto apertura.");
            return false;
        }

        var total = data.listaEfectivo.reduce((a, b) => a + (b["total"] || 0), 0)

        if (data.montoFinal != parseFloat(total)) {
            dialog.warning("El monto a final tiene que ser igual al monto total de efectivo.");
            return false;
        }
        return true;
    };

    handleCalculateDetail = (row, property, value, numberDecimals) => {

        /*********** Actualizar Detalle de Productos ********/
        var detalleProductos = this.props.form.getFieldValue("detalleSoles");

        var detalleProductosFilter = [];

        detalleProductos.forEach(element => {

            if (element.id === row.id) {
                detalleProductosFilter.push({
                    idCajaChica: this.props.formValues.id,
                    abreviatura: element.abreviatura,
                    cantidad: parseFloat(value),
                    formato: element.formato,
                    idEfectivo: element.id,
                    id: element.id,
                    idMoneda: element.id_Moneda,
                    monto: element.monto,
                    total: element.monto * value
                });

            } else {

                detalleProductosFilter.push({
                    idCajaChica: this.props.formValues.id,
                    abreviatura: element.abreviatura,
                    cantidad: parseFloat(element.cantidad),
                    formato: element.formato,
                    idEfectivo: element.id,
                    id: element.id,
                    idMoneda: element.id_Moneda,
                    monto: element.monto,
                    total: element.total
                });
            }


        });


        this.props.form.setFieldsValue({
            detalleSoles: detalleProductosFilter

        });


        this.props.formValues.listaEfectivoSoles = detalleProductosFilter;


    };

    handleCalculateDolar = (row, property, value, numberDecimals) => {

        /*********** Actualizar Detalle de Productos ********/
        var detalleProductos = this.props.form.getFieldValue("detalleDolares");

        var detalleProductosFilter = [];

        detalleProductos.forEach(element => {

            if (element.id === row.id) {
                detalleProductosFilter.push({
                    idCajaChica: this.props.formValues.id,
                    abreviatura: element.abreviatura,
                    cantidad: parseInt(value),
                    formato: element.formato,
                    idEfectivo: element.id,
                    id: element.id,
                    idMoneda: element.id_Moneda,
                    monto: element.monto,
                    total: element.monto * value
                });

            } else {

                detalleProductosFilter.push({
                    idCajaChica: this.props.formValues.id,
                    abreviatura: element.abreviatura,
                    cantidad: parseInt(element.cantidad),
                    formato: element.formato,
                    idEfectivo: element.id,
                    id: element.id,
                    idMoneda: element.id_Moneda,
                    monto: element.monto,
                    total: element.total
                });
            }


        });


        this.props.form.setFieldsValue({
            detalleDolares: detalleProductosFilter
        });

        this.props.formValues.listaEfectivoDolares = detalleProductosFilter;


    };

    render() {

        const { getFieldDecorator } = this.props.form;
        getFieldDecorator('id', { initialValue: this.props.formValues.id });

        getFieldDecorator("detalleSoles", {
            initialValue: this.props.formValues.listaEfectivoSoles,
        });


        getFieldDecorator("detalleDolares", {
            initialValue: this.props.formValues.listaEfectivoDolares,
        });

        return (
            <Modal
                title={"Registrar Cierre de Caja Chica"}
                visible={this.props.visible}
                cancelText={"Cancelar"}
                okText={"Guardar"}
                onCancel={this.handleCancel}
                onOk={this.handleOk}
                style={{ top: 30 }}
                width="900px"
            >
                <Form>

                    <div className="row">
                        <div className="col-md-4">
                            <Form.Item label="Serie Documento">

                                <InputGroup compact>
                                    <Form.Item style={{ width: "40%" }}>
                                        {getFieldDecorator("serie", {
                                            initialValue: this.props.formValues.serie,
                                            rules: [
                                                {
                                                    required: true,
                                                    message: "Requerido",
                                                },
                                            ],
                                        })(
                                            <Input
                                                readOnly
                                                className="text-right second-input"
                                                placeholder="Serie"
                                                autoComplete="off"
                                            />
                                        )}
                                    </Form.Item>
                                    <Form.Item style={{ width: "60%" }}>
                                        {getFieldDecorator("correlativo", {
                                            initialValue: this.props.formValues.correlativo,
                                            rules: [
                                                {
                                                    required: true,
                                                    message: "Correlativo",
                                                },
                                            ],
                                        })(
                                            <Input
                                                readOnly
                                                className="text-right second-input"
                                                placeholder="Ingresar Tipo de Cambio"
                                                autoComplete="off"
                                            />
                                        )}
                                    </Form.Item>
                                </InputGroup>


                            </Form.Item>
                        </div>
                        <div className="col-md-4">
                            <Form.Item label="Fecha Apertura">
                                <InputGroup compact>
                                    <Form.Item style={{ width: "65%" }}>
                                        {getFieldDecorator("fechaTipoCambio", {
                                            initialValue: moment(
                                                this.props.formValues.fechaTipoCambio,
                                                "DD/MM/YYYY"
                                            ),
                                            rules: [
                                                {
                                                    type: "object",
                                                    required: true,
                                                    message: "Requerido",
                                                },
                                            ],
                                        })(
                                            <DatePicker
                                                className="first-input"
                                                placeholder="Seleccione fecha"
                                                prefix={
                                                    <Icon
                                                        type="filter"
                                                        style={{ color: "rgba(0,0,0,.25)" }}
                                                    />
                                                }
                                                disabled={true}
                                                format="DD/MM/YYYY"
                                                onChange={(moment, value) =>
                                                    this.props.onChange(
                                                        "fechaStr",
                                                        value,
                                                        this.props.form
                                                    )
                                                }
                                            />
                                        )}
                                    </Form.Item>
                                    <Form.Item style={{ width: "35%" }}>
                                        {getFieldDecorator("tipoCambio", {
                                            initialValue: parseFloat(
                                                this.props.formValues.tipoCambio
                                            ).toFixed(3),
                                            rules: [
                                                {
                                                    required: true,
                                                    pattern: new RegExp(FORMAT_3DECIMALS),
                                                    message: "Formato decimal incorrecto (0.000)",
                                                },
                                            ],
                                        })(
                                            <Input
                                                className="text-right second-input"
                                                placeholder="Ingresar Tipo de Cambio"
                                                autoComplete="off"
                                                readOnly
                                            />
                                        )}
                                    </Form.Item>
                                </InputGroup>
                            </Form.Item>
                        </div>
                        <div className="col-md-4">
                            <Form.Item label={"Fecha Cierre"}>
                                {getFieldDecorator("fechaCierre", {
                                    initialValue: moment(
                                        this.props.formValues.fechaReferencial,
                                        "DD/MM/YYYY"
                                    ),
                                    rules: [
                                        {
                                            type: "object",
                                            required: true,
                                            message: "Requerido",
                                        },
                                    ],
                                })(
                                    <DatePicker
                                        className="first-input"
                                        placeholder="Seleccione fecha"
                                        prefix={
                                            <Icon
                                                type="filter"
                                                style={{ color: "rgba(0,0,0,.25)" }}
                                            />
                                        }
                                        format="DD/MM/YYYY"
                                        allowClear={false}
                                        readOnly
                                    />
                                )}
                            </Form.Item>
                        </div>
                        <div className="col-md-4">

                            <Form.Item label="Responsable de Arqueo">
                                <InputGroup compact>
                                    <Form.Item style={{ width: "100%" }}>
                                        {getFieldDecorator("idEmpleadoArqueo", {
                                            initialValue: this.props.formValues.idEmpleadoArqueo
                                                ? { key: this.props.formValues.idEmpleadoArqueo }
                                                : undefined,
                                            rules: [
                                                {
                                                    required: true,
                                                    message: "Campo obligatorio.",
                                                },
                                            ],
                                        })(

                                            <Select
                                                showSearch
                                                labelInValue
                                                placeholder={"Seleccione Responsable"}
                                                optionFilterProp="children"
                                            >
                                                {this.props.formValues.empleados.map(item => (
                                                    <Option key={item.id} value={item.id}>{item.numeroDocumento} - {item.nombre}</Option>
                                                ))}
                                            </Select>
                                        )}
                                    </Form.Item>
                                </InputGroup>
                            </Form.Item>

                        </div>
                        <div className="col-md-4">
                            <Form.Item label="Establecimiento">
                                {getFieldDecorator("idEstablecimiento", {
                                    initialValue: this.props.formValues.idEstablecimiento
                                        ? { key: this.props.formValues.idEstablecimiento }
                                        : undefined,
                                })(
                                    <Select
                                        showSearch
                                        labelInValue
                                        placeholder={"Seleccione Establecimiento"}
                                        optionFilterProp="children"
                                        onChange={(e) => this.props.onChange(e, null)}
                                    >
                                        {this.props.formValues.establecimientos.map((item) => (
                                            <Option key={item.id} value={item.id} disabled>
                                                {item.nombre}
                                            </Option>
                                        ))}
                                    </Select>
                                )}
                            </Form.Item>
                        </div>
                        <div className="col-md-4">
                            <Form.Item label="Caja">
                                {getFieldDecorator("idCaja", {
                                    initialValue: this.props.formValues.idCaja
                                        ? { key: this.props.formValues.idCaja }
                                        : undefined,
                                })(
                                    <Select
                                        showSearch
                                        labelInValue
                                        disabled={this.props.loadingChange}
                                        placeholder={"Seleccione Caja"}
                                        optionFilterProp="children"
                                    >
                                        {this.props.formValues.cajas.map((item) => (
                                            <Option key={item.id} value={item.id} disabled>
                                                {item.nombre}
                                            </Option>
                                        ))}
                                    </Select>
                                )}
                            </Form.Item>
                        </div>
                    </div>



                    <div className="row">
                        <div className="col-md-4">

                            <Form.Item label="Responsable de Caja">
                                <InputGroup compact>
                                    <Form.Item style={{ width: "100%" }}>
                                        {getFieldDecorator("idResponsable", {
                                            initialValue: this.props.formValues.idResponsable
                                                ? { key: this.props.formValues.idResponsable }
                                                : undefined,
                                        })(
                                            <Select
                                                showSearch
                                                labelInValue
                                                placeholder={"Seleccione Caja"}
                                                optionFilterProp="children"
                                                showArrow={false}
                                            >
                                                {this.props.formValues.empleados.map(item => (
                                                    <Option key={item.id} value={item.id} disabled>{item.nombre}</Option>
                                                ))}

                                            </Select>

                                        )}
                                    </Form.Item>

                                </InputGroup>


                            </Form.Item>

                        </div>
                        <div className="col-md-4">
                            <Form.Item label="Moneda">
                                {getFieldDecorator("idMoneda", {
                                    initialValue: this.props.formValues.idMoneda
                                        ? { key: this.props.formValues.idMoneda }
                                        : undefined,
                                })(
                                    <Select
                                        showSearch
                                        labelInValue
                                        placeholder={"Seleccione moneda"}
                                        optionFilterProp="children"
                                    >
                                        {this.props.formValues.monedas.map((item) => (
                                            <Option key={item.id} value={item.id} disabled>
                                                {item.nombre}
                                            </Option>
                                        ))}
                                    </Select>
                                )}
                            </Form.Item>
                        </div>
                        <div className="col-md-4">
                            <Form.Item label="Monto de Apertura">
                                {getFieldDecorator(`montoApertura`, {
                                    initialValue: parseFloat(this.props.formValues.montoApertura).toFixed(2),
                                    rules: [{
                                        required: true,
                                        pattern: new RegExp(FORMAT_2DECIMALS),
                                        message: "Formato (0.00)"
                                    }
                                    ]
                                })(
                                    <Input
                                        placeholder="Monto Pen"
                                        autoComplete="off"
                                        readOnly

                                    />
                                )}
                            </Form.Item>
                        </div>
                        <div className="col-md-4">
                            <Form.Item label="Monto Final">
                                {getFieldDecorator(`montoSaldo`, {
                                    initialValue: parseFloat(this.props.formValues.montoSaldo).toFixed(2),
                                    rules: [{
                                        required: true,
                                        pattern: new RegExp(FORMAT_2DECIMALS),
                                        message: "Formato (0.00)"
                                    }
                                    ]
                                })(
                                    <Input
                                        placeholder="Monto Pen"
                                        autoComplete="off"
                                        readOnly

                                    />
                                )}
                            </Form.Item>
                        </div>
                        <div className="col-md-4">
                            <Form.Item label="Proyecto">
                                {getFieldDecorator("idProyecto", {
                                    initialValue: this.props.formValues.idProyecto
                                        ? { key: this.props.formValues.idProyecto }
                                        : 0,
                                })(
                                    <Select
                                        showSearch
                                        labelInValue
                                        placeholder={"Seleccione Proyecto"}
                                        optionFilterProp="children"
                                    >
                                        <Option key={0} value={0}>
                                            <span style={{ color: "#bfbfbf" }}>Ninguno</span>
                                        </Option>
                                        {this.props.formValues.proyectos.map(item => (
                                            item.estado ?
                                                <Option key={item.id} value={item.id}>{item.nombre}</Option>
                                                : null
                                        ))}
                                    </Select>
                                )}
                            </Form.Item>
                        </div>
                    </div>


                    <div className="row">
                        <div className="col-md-12">
                            <Tabs>
                                <TabPane tab="Cierre de arqueo - EFECTIVO" key="1">
                                    <div className="row">
                                        <div className="col-md-2">
                                        </div>
                                        {this.props.formValues.idMoneda == 1 ?
                                            <div className="col-md-8">
                                                <CierreSoles
                                                    dataSource={this.props.formValues.listaEfectivoSoles}
                                                    onGetFieldDecorator={getFieldDecorator}
                                                    onCalculateDetail={this.handleCalculateDetail}
                                                />
                                            </div> :
                                            <div className="col-md-8">
                                                <CierreDolares
                                                    dataSource={this.props.formValues.listaEfectivoDolares}
                                                    onGetFieldDecorator={getFieldDecorator}
                                                    handleCalculateDolar={this.handleCalculateDolar}
                                                />
                                            </div>
                                        }
                                    </div>
                                </TabPane>
                            </Tabs>
                        </div>
                    </div>
                </Form>
            </Modal>
        );
    }
}
export default Form.create()(FormModal)